import {
  Text,
  BorderRadius4,
  CustomerLogo,
  GreyGrey10,
  GreyGrey90,
  Primary14SemiBold,
  Center,
  Flex
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/utils/logo'
import { CustomerInfoReviewViewModel } from '../../types'

/**
 * Modal title bar for the review: the customer logo, the customer name, and the
 * current step's subject (e.g. "Billing contacts").
 */
export const CustomerInfoReviewHeader = ({
  customer,
  stepTitle
}: {
  customer: CustomerInfoReviewViewModel['customer']
  stepTitle: string
}) => {
  return (
    <Flex alignItems="center" gap="8px" overflow="hidden">
      <Center
        borderRadius={BorderRadius4}
        overflow="hidden"
        boxSize="24px"
        background={GreyGrey10}
        flexShrink={0}
      >
        <CustomerLogo
          src={getLogoSrc(customer)}
          size={24}
          fallbackSize={16}
          data-testid="customerInfoReview.header.logo"
        />
      </Center>
      <Flex alignItems="center" gap="6px" overflow="hidden">
        <Text {...Primary14SemiBold} color={GreyGrey90} whiteSpace="nowrap">
          {customer.legalName}:
        </Text>
        <Text
          {...Primary14SemiBold}
          color={GreyGrey90}
          flexShrink={0}
          whiteSpace="nowrap"
          data-testid="customerInfoReview.stepTitle"
        >
          {stepTitle}
        </Text>
      </Flex>
    </Flex>
  )
}
